const TestimonialCard = (props) => {
  return (
    <div className="testimonial-card box-shadow">
      <p className="testimonial-text font-inter-regular box-shadow">{props.testimonial}</p>
      <div className="testimonial-profile flex">
        <img src={props.logo} alt={props.name} className="org-logo-emp box-shadow" />
        <div className="box-shadow padding-8 width-100 border-radius-2">
          <p className="emp-name boldTitle">{props.name}</p>
          <span className="emp-profile font-inter-regular">{props.profile}</span>
        </div>
      </div> 
    </div>
  );
};

export default TestimonialCard;
